import { createTheme } from '@mui/material/styles';

import myColors from './myColors';

const font = {
    headings: "'ivyora-display', serif",
    body: "'gesta', 'Ubuntu', sans-serif"
}

function mydynamictheme(mode) {

  let theme = createTheme({
    palette: {
        mode,
        ...(mode === 'light'
        ? { 
            primary: {
                main: myColors.primary.main,
                light: myColors.primary.light
            }}
        :{ 
            primary: {
                main: myColors.primary.main,
                light: myColors.dark.light
            }
        })
    }
    ,
    typography: {
      'h2': {
        fontFamily: font.headings,
        fontWeight: 600,
        fontStyle: 'normal',
        color: mode === 'light' ? myColors.primary.main : myColors.whiteGray
      },
      'h3': {
        fontFamily: font.headings,
        fontWeight: 600,
        fontStyle: 'normal',
        color: mode === 'light' ? myColors.primary.main : myColors.whiteGray
      },
      'h4': {
        fontFamily: font.headings,
        fontWeight: 600,
        fontStyle: 'normal',
        color: mode === 'light' ? myColors.primary.main : myColors.whiteGray
      },
      'h5': {
        fontFamily: font.headings,
        fontWeight: 600,
        fontStyle: 'normal',
        color: mode === 'light' ? myColors.primary.main : myColors.whiteGray,
        fontSize: '1.7rem'

      },
      // TODO light italic
      'subtitle1': {
        fontFamily: font.body,
        fontWeight: 300,
        fontStyle: 'normal'
      },
      'subtitle2': {
        fontFamily: font.headings,
        fontWeight: 300,
        fontStyle: 'italic'
      },
      'body1': {
        fontFamily: font.body,
        color: mode === 'light' ? myColors.purpleBlack : myColors.whiteGray,
        fontSize: '1.2rem'
      },
      'body2': {
        fontFamily: font.body
      }
    },
    components: {
      // Name of the component
      MuiAppBar: {
        styleOverrides: {
          // Name of the slot
          colorPrimary: (({ theme }) => ({
            backgroundColor: 'transparent',
            [theme.breakpoints.down('lg')]: {
              backgroundColor: myColors.whiteGray,
            },
            [theme.breakpoints.up('lg')]: {
              backgroundColor: 'transparent',
            },
          })),
          root: {
            // Some CSS
            boxShadow: 'none'
          },
        }
      },
      MuiChip: {
        styleOverrides: {
          // Name of the slot
          root: {
            fontFamily: font.body,
            fontWeight: 700,
            fontStyle: 'normal',
            textTransform: 'uppercase',
            margin: '4px 12px 16px 0px',
          },
        }
      },
      MuiCard:{
        styleOverrides: {
          root: {
            boxShadow: 'none',
            backgroundColor: mode === 'light' ? myColors.whiteGray : myColors.purple
          }
        }
      },
      MuiButton: {
        styleOverrides: {
          root: {
            fontFamily: font.body,
            fontWeight: 700,
            fontStyle: 'normal',
            textTransform: 'uppercase',
            margin: '4px 12px 16px 0px',
          },
          textPrimary: {
            color: mode === 'light' ? myColors.primary.main : myColors.whiteGray
          },
          textSecondary: {
            color: mode === 'light' ? myColors.primary.light : myColors.dark.light
          }
        }
      },
      MuiMenuItem: {
        styleOverrides: {
          root: ({ theme }) => ({
            ...theme.typography.button, // Copy all button typography
            textTransform: 'uppercase', // Ensure uppercase
          })
        }
      }
    }
  })

  return theme
}

export default mydynamictheme